import { Component, type ErrorInfo, type ReactNode } from 'react';
import { MapPinOff } from 'lucide-react';

interface MoRouteMapBoundaryProps {
  children: ReactNode;
}

interface MoRouteMapBoundaryState {
  failed: boolean;
}

export class MoRouteMapBoundary extends Component<
  MoRouteMapBoundaryProps,
  MoRouteMapBoundaryState
> {
  state: MoRouteMapBoundaryState = { failed: false };

  static getDerivedStateFromError(): MoRouteMapBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('MO route map failed to render', error, info);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="flex h-full min-h-64 flex-col items-center justify-center gap-2 text-muted-foreground">
          <MapPinOff className="size-6" aria-hidden />
          <p className="text-sm">
            The map could not be loaded. Entries are still listed in the timeline.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
